<!--
 * @Author: your name
 * @Date: 2021-06-29 09:14:46
 * @LastEditTime: 2021-06-30 14:23:59
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\views\one_card\balance.vue
 * 余额显示界面等
-->
<template>
  <div class="balance">
      <div class="top">
          <div class="content">
              <!-- <div class="img">{{avtier}}</div> -->
              <van-image
                    round
                    width="4rem"
                    height="4rem"
                    :src="require('.././img/avatar.png')" rel="external nofollow" 
                    class="img"
                />
              <div class="content-r">
                  <div style="font-size:1.2rem;font-weight:bold">{{currentInfo.name}}</div>
                  <div style="font-size:0.88rem">一卡通号({{currentInfo.schoolCardNum}})</div>
              </div>
          </div>
      </div>
     <div class="balance_title">
         <div class="font_style">
             <div style="color:#aaa;">今日消费(元)</div>
             <div class="num_style">{{fin}}</div>
         </div>
          <div class="font_style">
             <div style="color:#aaa;">余额(元)</div>
             <div class="num_style">{{balance}}</div>
         </div>
     </div>
     <div class="center">
         <div class="center-box">
             <div class="line"></div>
             <div class="div"><img src="../img/chongzhi.png" style="width:1.5rem" alt=""><span style="margin-left:1rem" @click="chongzhi">充值记录</span></div>
             <div class="div"><img src="../img/xiaofei.png" style="width:1.5rem" alt=""><span style="margin-left:1rem" @click="xiaofei">消费记录</span></div>
         </div>
     </div>
     <div style="width:95%;margin:0 auto;">
        <van-button type="primary"  size="large" style="margin-bottom:1rem;background:#F5AD3F;border:0px;margin-top:1rem;border-radius:8px" @click="toList">立即充值</van-button>
        <!-- <van-button type="default" size="large" @click="expensesRecord" color="#f7f7f7;"><span style="color:#aaa;">查看近两个月交易记录</span></van-button> -->
     </div>
  </div>
</template>

<script>
import {getBalance,getFin,getEcode} from '@/api/http'
import { Toast } from 'vant';
export default {
  name: 'manualBind',
  components: {
  
  },
  data(){
    return{
        avtier:null,
        currentInfo:{},
        balance:"-- : --",
        fin:"-- : --",
        schoolId:"",
        } 
  },
  methods:{
        //交易记录查询
        expensesRecord(){
            this.$router.push('/expensesRecord')
        },
        //充值跳转
        toList(){
            getEcode(this.schoolId).then(res=>{
                if(res.data.code === 200){
                    if(res.data.data == null){
                        Toast.fail('该校暂无合作快e通');
                    }else{
                        let code = res.data.data[0]
                        window.location.href = `https://enjoy.abchina.com/jf-web/epayItem?code=`+code
                    }
                }else{
                    Toast.fail(res.data.msg);
                }
                
            })
            // this.$router.push('/recharge')
            
        },
        //消费记录
        xiaofei(){
            this.$router.push('/expensesRecord')
        },
        //充值记录
        chongzhi(){
            this.$router.push('/rechargeRecord')
        },
  },
  mounted(){
      this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
      this.schoolId = this.currentInfo.schoolId
      this.avtier = this.currentInfo.name.slice(0,1)
      console.log(this.currentInfo)
      getBalance(this.currentInfo.schoolId,this.currentInfo.id).then(res=>{
          console.log(res)
           let balance_ = '0.00';
            if(res.data.data.subBalance){
            balance_ = parseFloat(res.data.data.cashBalance) + parseFloat(res.data.data.subBalance)
            }else{
            balance_ = parseFloat(res.data.data.cashBalance)
            }
        
            this.balance = (Number(balance_)/100).toFixed(2)
            console.log(this.balance)
            if(isNaN(this.balance)){
                this.balance = "-- : --"
            }
      }).catch(res=>{
          this.balance = "-- : --"
      })
    let data = {
    //   end: new Date(),
    //   start: new Date(),
      pageNum: 1,
      pageSize: 10000,
      userId: this.currentInfo.id
    }
    getFin(this.currentInfo.schoolId,data).then(res=>{
        console.log(res)
        // console.log((Number('3.511') + 7).toFixed(2))
        if(res.data.code == 200){
            let amount = 0
            if(res.data.data.datas){
                if(res.data.data.datas.length != 0){
                    res.data.data.datas.forEach(item=>{
                        amount += Number(item.amount)
                    })
                    this.fin = amount.toFixed(2)
                }else{
                    this.fin = "0.00"
                }
            }else{
                this.fin = "0.00"
            }
            // if(res.data.data.datas.length != 0 && res.data.data.datas){
            //     res.data.data.datas.forEach(item=>{
            //         amount += Number(item.amount)
            //     })
            //     this.fin = amount
            // }else{
            //     this.fin = "0.00"
            // }
        }
    }).catch(res=>{
        this.fin = "-- : --"
    })
  }
}
</script>
<style scoped>
    .balance{
        width: 100%;
        height: 100%; 
        background-color: #fff;
    }
    .balance_title{
        width:75%;
        margin:0 auto;
        margin-top: 2rem;
        display:flex;
        justify-content:space-between;
    }
    .font_style{
        text-align: center;
    }
    .num_style{
        margin:1.875rem 0rem;
        font-size: 1.5rem;
        font-weight: 800;
    }
    .top{
        width: 100%;
        height: 8rem;
    }
    .content{
        width:95%;
        margin: 0 auto;
        height: 100%;
        background:url("../img/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .img{
        width: 3.44rem;
        height: 3.44rem;
        border-radius: 50%;
        line-height: 3.44rem;
        text-align: center;
        font-size:2rem;
        color: #fff;
        margin-left: 1rem;
    }
    .content-r{
        height: 3.44rem;
        width: 75%;
        display: flex;
        align-content: space-around;
        flex-wrap: wrap;
        margin-left: 1rem;
    }
    .content-r div{
        height: 1rem;
        width: 100%;
        font-size: 1rem;
        line-height: 1rem;
        color:#fff
    }
    .center{
        width: 100%;
        height: 2rem;
        margin-bottom: 1rem;
    }
    .center-box{
        width: calc(100% - 2rem);
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        position: relative;
    }
    .line{
        height:100%;
        width:0.5px;
        background:#DEDEDE;
        position:absolute;
        left:50%;
        transform: translateX(-50%);
    }
    .div{
        height: 100%;
        color: #666;
        line-height: 2rem;
        font-size: 0.81rem;
        display: flex;
        align-items: center;
    }
</style>